import { styled } from '@mui/material/styles';

import { Theme, rem, remToGapMultiplier } from '../../theme';

type StyledPromoTileLayoutProperties = {
    $maxWidth: number;
    $numberOfColumns: number;
};

export const StyledContainer = styled('div')`
    ${({ theme }: { theme: Theme }) => `
        margin: ${theme.tggSpacing(rem(2.5), 6.25)};
    `}
`;

export const StyledPromoTileLayout = styled(
    'div',
)<StyledPromoTileLayoutProperties>`
    ${({
        theme,
        $maxWidth,
        $numberOfColumns,
    }: StyledPromoTileLayoutProperties & { theme: Theme }) => `
        display: grid;
        grid-template-rows: auto;
        grid-template-columns: repeat(1, minmax(calc(100% - ${theme.tggSpacing(rem(2.5), 6.25)}), 1fr));
        gap: ${theme.tggSpacing(rem(2.5), 6.25)};
        max-width: ${theme.tggSpacing(rem($maxWidth / 10), ($maxWidth / 10) * remToGapMultiplier)};
        margin: ${theme.tggSpacing([0, 'auto'], [0, 'auto'])};

        ${theme.breakpoints.up('desktop')} {
            grid-template-columns: repeat(${$numberOfColumns}, minmax(calc(100% / ${$numberOfColumns} - ${theme.tggSpacing(rem(2.5), 6.25)}), 1fr));
        }
	`}
`;
